import { environment } from "@environment/environment"

export const urlAuth = environment.apiService_Auth
export const urlSoporte = environment.apiService
export const urlCRM = environment.apiService_CRM
export const urlErp = environment.apiService_Erp
export const urlReport = environment.apiService_Report
export const urlExport = environment.apiService_Export
export const urlProduccion = environment.apiService_Produccion
export const urlAdjuntos = environment.apiService_Adjuntos
export const urlFE = environment.apiService_FE
export const urlConfig = environment.apiService_Config
export const urlPlanilla = environment.apiService_Planilla
export const urlIA = environment.apiService_Ia
export const urlRewriter = environment.apiService_Rewriter
export const urlEtiquetas = environment.apiService_Etiquetas
export const urlFormula = environment.apiService_Formula
export const urlScrap = environment.apiService_Scrap
export const urlAsistencia = environment.apiService_Asistencia